import React, { useEffect, useState } from 'react'

// Path
import { PATH_NOT_FOUND, PATH_TICKET_SUPPORT } from 'routes/paths'

// Use
import useMounted from 'use/mounted'
import { useHistory, useParams } from 'react-router-dom'
import useQuery from 'use/query'
import { useDispatch } from 'react-redux'

// Models
import TicketInfoModel from 'models/Ticket'

// Notifications slice
import { markAsRead } from 'store/modules/notifications'

// Api
import { getTicketInfo } from 'api/ticket'

// Components
import Header from 'ui/Header'
import Navbar from 'ui/Navbar'
import Container from 'ui/Container'
import Breadcrumb from 'ui/Breadcrumb'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Text from 'ui/Text'
import Skeleton from 'ui/Skeleton'
import Footer from 'ui/Footer'
import TicketInfo from 'components/Ticketing/TicketInfo/TicketInfo'
import TicketCommentForm from 'components/Ticketing/TicketInfo/TicketCommentForm'
import TicketCommentList from 'components/Ticketing/TicketInfo/TicketCommentList'

export default function PageTicketsView() {
  const dispatch = useDispatch()
  const isMounted = useMounted()
  const history = useHistory()

  const [ticket, setTicket] = useState(new TicketInfoModel())
  const [loading, setLoading] = useState(false)
  const { id } = useParams()
  const { notificationId } = useQuery()

  // Show confirm if status is resolved
  const [isResolved, setIsResolved] = useState(false)
  // Hide comment if closed
  const [isClosed, setIsClosed] = useState(false)

  const showCommentForm = isResolved === false && isClosed === false
  const showResolveConfirm = isResolved && isClosed === false

  useEffect(() => setIsClosed(ticket.isClosed), [ticket.isClosed])
  useEffect(() => setIsResolved(ticket.isResolved), [ticket.isResolved])

  useEffect(() => {
    setLoading(true)

    dispatch(markAsRead(notificationId))

    getTicketInfo({ id, notificationId })
      .then((data) => {
        if (isMounted.current) {
          setTicket(data)
        }
      })
      .catch(() => {
        history.replace(PATH_NOT_FOUND)
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
  }, [dispatch, history, id, isMounted, notificationId])

  const breadcrumbs = [
    {
      label: 'Help & support',
      path: PATH_TICKET_SUPPORT,
    },
    {
      label: ticket.category,
    },
  ]

  return (
    <>
      <Header />
      <Navbar />
      <Container>
        <Breadcrumb items={breadcrumbs} />
        <Row>
          <Col xs={12} md={9} lg={7}>
            <Skeleton loading={loading} paragraph={{ rows: 10 }} avatar>
              <Text
                style={{
                  lineHeight: '1.2',
                  color: '#070707',
                  fontWeight: 'bold',
                  fontSize: '30px',
                  paddingBottom: '10px',
                  wordBreak: 'break-word',
                }}
              >
                {ticket.category}
              </Text>

              <TicketInfo ticket={ticket} />

              <Text bold color="#000000" paddingTop={50} paddingBottom={10}>
                Comments:
              </Text>

              {showCommentForm && <TicketCommentForm ticketId={id} />}

              <TicketCommentList
                ticketId={id}
                showResolveConfirm={showResolveConfirm}
                isCommentFormVisible={showCommentForm}
                onTicketClosed={() => setIsClosed(true)}
                onCancel={() => setIsResolved(false)}
              />
            </Skeleton>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  )
}
